import { createClient } from '@supabase/supabase-js';

export const SUPABASE_URL = 'https://ggeeqexormqnazwxzbsy.supabase.co';
export const SUPABASE_ANON_KEY =
  'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImdnZWVxZXhvcm1xbmF6d3h6YnN5Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3Nzk1OTk0ODAsImV4cCI6MjA5NTE3NTQ4MH0.9yLlP94KArsxw8qNqLsLsrErG03djcqJkJPEqtUhOl0';

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
  auth: {
    detectSessionInUrl: true,
    persistSession: true,
    storageKey: 'web3kurzus-auth',
    flowType: 'implicit',
  },
});
